import { t } from '../../../lib/i18n';
import { type RelayStatus } from '../types';
import { RELAY_STATUS_CHIP, cn, relayStatusTranslationKey } from '../utils';

/**
 * Relay-desk pipeline chip (captured → queued → relayed → won/lost/cancelled).
 *
 * Design D drops the lucide icon the ported web badge carried. At the 10px the
 * artboard sets, a 12px glyph beside four upper-case words is noise, and the
 * six states are already distinguished by colour and by their own wording; the
 * icon only cost horizontal room the «Ретрансляція» column does not have.
 */
export function RelayStatusBadge({
  relayStatus,
  className,
}: {
  relayStatus: RelayStatus;
  className?: string;
}) {
  const chip = RELAY_STATUS_CHIP[relayStatus];
  if (!chip) return null;

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-cf-sm px-[7px] py-[3px] font-mono text-[9px] tracking-[0.08em] whitespace-nowrap uppercase lg:px-2 lg:py-1 lg:text-[10px]',
        chip,
        className,
      )}
    >
      {t(relayStatusTranslationKey(relayStatus))}
    </span>
  );
}
